module.exports = __webpack_public_path__ + "static/img/fwnt.ea453e13.png";